<template>
  <div class="text-center">
    <v-dialog v-model="dialog" persistent>
      <v-card class="np-card">
        <v-card-title class="np-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="deep-orange darken-3"> mdi-account </v-icon>
            </v-avatar>
            <div>
              <div class="text-h6">Terminos y condiciones:</div>
              <div class="text-body-2 opacity-80"> 
              </div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="ma-0 pa-0" style="max-height: 520px; overflow-y: auto;">
          <v-progress-linear indeterminate v-if="loading" /> 
          <iframe :srcdoc="terminos.contenido" width="100%" height="480" frameborder="0"></iframe>
          <iframe v-show="false" ref="miIframe" :srcdoc="terminos.contenido" width="100%" height="480" frameborder="0"></iframe>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <span> {{ enlace }} </span>
          <v-spacer></v-spacer>
          <!-- <v-btn color="green" text @click="generateReport()">PDF</v-btn> -->
          <v-btn color="green" text @click="copyenlace()">Copiar Link</v-btn>
          <v-btn color="grey" text @click="cerrar()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { terminos_condicion } from './utils';  

  export default {
    components:{ },
    data() {
      return {
        loading: false,
        dialog: false,
        terminos: {},
        ins: {},
        enlace:'',
      };
    },
    methods: {
      // xins es contacto 
      async openmodal(xins) { 
        this.ins = xins;
        this.enlace = ''
        this.dialog = true;
        this.generateLink()
        this.listar();
      },
      async listar(){
        this.loading = true;
        let unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;
        const q = {
          unidad_negocio: unidad_negocio_id
        }
        this.loading = false;
        const r = await terminos_condicion(q)
        this.terminos = r
        window.console.log('rrrr',r); 
      },
      async generateLink(){
        const persona_id = null;
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        const contactoid = this.ins.id
        const host = window.location.hostname
        
        const raw = [contactoid, persona_id, host, unidad].join('|')
        const token = btoa(String.fromCharCode(...new TextEncoder().encode(raw))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '')

        
        /* const mapa = {
          1: `https://formulario.esam.edu.bo/index_terms.html?t=${token}`,
          5: `https://formulario.esamlatam.com/index_terms.html?t=${token}`,
          14: `https://formulario.ispi.edu.pa/index_terms.html?t=${token}`,
          15: `https://formulario.upi.edu.pa/index_terms.html?t=${token}`,
        }
        
        let link = mapa[unidad]
        if(!link) link = mapa[1] */

        let link = `http://localhost:5007/index_terms.html?t=${token}`

        let apidev = process.env.VUE_APP_GRAPHQL;
        if( apidev.includes("apidev") ){
          link = link.replaceAll('formulario.','formulariotest.')
        }
        this.enlace = link; 
      },
      async copyenlace(){
        await navigator.clipboard.writeText(this.enlace);
        document.execCommand('copy');
        this.$root.$notify.show(`Link copiado, ahora envialo al contacto para que acepte.`, {color:'green',x: 'center', y:'bottom',});
      },
      /*generateReport() {
        
        const iframe = this.$refs.miIframe
        
        const doc =
        iframe.contentDocument ||
        iframe.contentWindow.document;
        
        const body = doc.querySelector('body')
        if (body) {
          body.style.margin = '0'
          body.style.padding = '2em'
        }
        this.$refs.miIframe.contentWindow.print()
      },*/
      cerrar(){
        this.dialog = false
      }
    },
    mounted() {}, 
  };
</script>

